module.exports = __webpack_public_path__ + "static/media/eli_and_ravneet.8da8086e.jpg";